<template>
  <div class="404-page">
    <div
      class="empty-img-box"
    >
      <img
        src="@/assets/images/blank.png"
        class="logo-img"
      >
      <p class="placeholder">
        {{ text }}
      </p>
      <a-button
        type="primary"
        @click="handleClick"
      >
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      text: '当前项目已被关闭，可联系组织创始人/管理员开启'
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    cid () {
      return this.baseinfo.cid
    },
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    }
  },
  methods: {
    handleClick () {
      this.$router.push({
        // path: `/organization/project?cid=${this.cid}&type=inquery`,
        name: 'ProjectIndexPc',
        query: {
          cid: this.cid,
          type: 'inquery'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.empty-img-box {
  padding: 144px 0;
  text-align: center;
  .logo-img {
    width: 160px;
    margin: 0 auto;
  }
  .placeholder {
    margin-bottom: 24px;
    font-size: 14px;
    color: #B3B3B3;
  }
  .btn {
    margin: 12px 0;
  }
}
</style>
